import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


export interface LogEntry {
  method: string,
  message: string,
  type: string
}
@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor(private httpClient: HttpClient) { }
  private async _write2log(entry: LogEntry) {

    try {
      if (entry.type == "E")
        console.error(entry.method, entry.message, entry.type);
      else
        console.debug(entry.method, entry.message, entry.type);
      await this.httpClient.post("api/log/clientwrite2log", entry).toPromise();
    } catch (e) {
      console.log(e.message);
    }
  }

  public async write2log(method: string, message: string, type: string = "P") {
    await this._write2log({ method: method, message: message, type: type})
  }

  public async logInternalError(method: string, error: Error) {
    await this._write2log({ method: method, message: error.message, type: "E" });
  }

  public async logApiError(response, method) {

    if (method === undefined) method = "Unknown method";
    var statusText = "Unknown status";
    if ('statusText' in response) statusText = response.statusText;

    var message = "No message";
    try {
      if ('data' in response) {
        var responseData = response.data;
        if (responseData !== null && responseData !== undefined && 'responseStatus' in responseData) {
          var responseStatus = responseData.responseStatus;
          if ('message' in responseStatus) message = responseStatus.message;
        }
      }
    } catch (e) {
      // Do nothing
    }

    var url = "";
    if (response && response.config)
      url = response.config.url;

    var data = { status: statusText, message: message, method: method, url: url };
    console.debug("[E] ApiError: " + message);

    await this.httpClient.post("api/log/clientapierror", data).toPromise();

    return response;
  }
}
